export default "__VITE_ASSET__BoAXuBDa__"